<!-- Loading state -->
@if (loading) {
  <div class="loading-state">
    <mat-icon>hourglass_empty</mat-icon>
    <p>Adatok betöltése...</p>
  </div>
}

<!-- Error state -->
@else if (error) {
<div class="error-state">
  <mat-icon>error</mat-icon>
  <p>Hiba történt az adatok betöltése során.</p>
</div>
}

<!-- Logs list -->
@else if (paginatedLogs.length) {
<div class="logs-timeline">
  @for (log of paginatedLogs; track log.id) {
    <div class="log-item {{ getIconClass(log.status, log) }}">
      <div class="log-icon">
        <mat-icon>{{ getHistoryIcon(log.status, log) }}</mat-icon>
      </div>

      <div class="log-content">
        <!-- Kompakt header -->
        <div class="log-header">
          <span class="log-date">{{ formatDate(log.date) }}</span>
          @if (log.status) {
            <div class="status-block">
              <span [ngClass]="getStatusBadgeClass(log.status)">{{ log.status }}</span>
            </div>
          }
          <span class="log-user">{{ log.created_by }} ({{ log.user_jobtitle }})</span>
        </div>

        <!-- 2 oszlopos tartalom -->
        <div class="log-body">
          <!-- Bal oszlop: Cég/ügyfél adatok -->
          <div class="log-left">
            @if (log.company_name || log.customer_name) {
              <div class="company-block">
                @if (log.company_name) {
                  <div class="company-name">
                    <mat-icon>business</mat-icon>
                    {{ log.company_name }}
                  </div>
                }
                @if (log.company_registration_number) {
                  <div class="company-reg">
                    {{ log.company_registration_number }}
                  </div>
                }
                @if (log.customer_name) {
                  <div class="customer-name">
                    <mat-icon>person</mat-icon>
                    {{ log.customer_name }}
                  </div>
                }
              </div>
            }
          </div>

          <!-- Jobb oszlop: Változások és megjegyzések -->
          <div class="log-right">
            <!-- Közös változások konténer -->
            @if (log.affected_entities || log.notes) {
              <div class="changes-container">
                <!-- Másolás gomb "Adatok feltöltése" és "Adatok kiegészítése" státusz esetén -->
                @if (log.status === 'Adatok feltöltése' || log.status === 'Adatok kiegészítése') {
                  <button class="copy-log-btn" mat-icon-button
                    (click)="copyLogContent($event)"
                    matTooltip="Tartalom másolása">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                }
                <!-- Biztosító műveletek megjelenítése -->
                @if (log.affected_entities && log.affected_entities[0] && log.affected_entities[0].insurance_company) {
                  <div class="change-item insurance-change">
                    @if (log.affected_entities[0].action === 'updated' && log.affected_entities[0].changes) {
                      <span class="change-details">
                        <mat-icon>edit</mat-icon>
                        {{ log.affected_entities[0].changes.old_name }} → {{ log.affected_entities[0].changes.new_name }}
                      </span>
                    } @else if (log.affected_entities[0].action === 'created') {
                      <span class="change-details">
                        <mat-icon>add_circle</mat-icon>
                        Új biztosító létrehozva: {{ log.affected_entities[0].insurance_company }}
                      </span>
                    } @else if (log.affected_entities[0].action === 'deleted') {
                      <span class="change-details">
                        <mat-icon>delete</mat-icon>
                        Biztosító törölve: {{ log.affected_entities[0].insurance_company }}
                      </span>
                    }
                  </div>
                }
                <!-- User műveletek megjelenítése -->
                @if (log.affected_entities && ((isArray(log.affected_entities) && log.affected_entities[0]?.user_id) || (!isArray(log.affected_entities) && log.affected_entities.user_id))) {
                  @let userEntity = isArray(log.affected_entities) ? log.affected_entities[0] : log.affected_entities;
                  <div class="change-item user-change">
                    <div class="user-header">
                      <span class="change-details">
                        @if (log.status === 'Felhasználó létrehozása') {
                          <mat-icon>person_add</mat-icon>
                        } @else if (log.status === 'Felhasználó módosítása') {
                          <mat-icon>person</mat-icon>
                        } @else if (log.status === 'Felhasználó törlése') {
                          <mat-icon>person_remove</mat-icon>
                        }
                        <strong>{{ userEntity.fullname }}</strong> ({{ userEntity.username }})
                        <span class="user-id-badge">
                          <mat-icon>tag</mat-icon>
                          User ID: {{ userEntity.user_id }}
                        </span>
                      </span>
                    </div>
                    <!-- Változások megjelenítése módosítás esetén -->
                    @if (log.status === 'Felhasználó módosítása' && userEntity.changes && Object.keys(userEntity.changes).length > 0) {
                      <div class="user-changes">
                        @for (changeKey of Object.keys(userEntity.changes); track changeKey) {
                          <div class="user-change-item">
                            <div class="change-field-name">
                              <mat-icon>edit</mat-icon>
                              {{ getUserFieldLabel(changeKey) }}
                            </div>
                            <div class="change-values">
                              <span class="old-value">{{ userEntity.changes[changeKey].old || '-' }}</span>
                              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                              <span class="new-value">{{ userEntity.changes[changeKey].new }}</span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                <!-- Termék műveletek megjelenítése -->
                @if (log.affected_entities && log.affected_entities[0] && log.affected_entities[0].product) {
                  <div class="change-item product-change">
                    @if (log.affected_entities[0].action === 'created') {
                      <span class="change-details">
                        <mat-icon>add_circle</mat-icon>
                        <strong>{{ log.affected_entities[0].product.name }}</strong> ({{ log.affected_entities[0].product.code }})
                      </span>
                      <span class="product-details">
                        <mat-icon>business</mat-icon>
                        {{ log.affected_entities[0].product.company }} - {{ log.affected_entities[0].product.type }}
                      </span>
                    } @else if (log.affected_entities[0].action === 'updated' && log.affected_entities[0].changes) {
                      <span class="change-details">
                        <mat-icon>edit</mat-icon>
                        {{ log.affected_entities[0].product.company }} - {{ log.affected_entities[0].product.type }}
                      </span>
                      @if (log.affected_entities[0].changes && Object.keys(log.affected_entities[0].changes).length > 0) {
                        <div class="changes-list">
                          @for (changeKey of Object.keys(log.affected_entities[0].changes); track changeKey) {
                            <span class="change-detail-item">
                              <!-- <strong>{{ getChangeLabel(changeKey) }}:</strong> -->
                              {{ log.affected_entities[0].changes[changeKey].old }} → {{ log.affected_entities[0].changes[changeKey].new }}
                            </span>
                          }
                        </div>
                      }
                    } @else if (log.affected_entities[0].action === 'deleted') {
                      <span class="change-details">
                        <mat-icon>delete</mat-icon>
                        <strong>{{ log.affected_entities[0].product.name }}</strong> ({{ log.affected_entities[0].product.code }})
                      </span>
                      <span class="product-details">
                        <mat-icon>business</mat-icon>
                        {{ log.affected_entities[0].product.company }} - {{ log.affected_entities[0].product.type }}
                      </span>
                    }
                  </div>
                }
                <!-- Megjegyzés műveletek megjelenítése -->
                @if (log.status === 'Új megjegyzés' || log.status === 'Megjegyzés szerkesztése' || log.status === 'Megjegyzés törlése') {
                  @let noteEntities = isArray(log.affected_entities) ? log.affected_entities[0] : log.affected_entities;
                  @if (noteEntities) {
                    <div class="change-item plan-changes">
                      @if (noteEntities['modul']) {
                        <div class="plan-notes">
                          @if (log.notes) {
                            <span class="plan-date">
                              <mat-icon>calendar_month</mat-icon>
                              {{ log.notes }}
                            </span>
                          }
                          @if (noteEntities['user_name']) {
                            <span class="plan-user">
                              <mat-icon>account_circle</mat-icon>
                              {{ noteEntities['user_name'] }}
                            </span>
                          }
                        </div>
                      }
                      @if (noteEntities['régi_megjegyzés']) {
                        <div class="plan-change-item">
                          <span class="plan-field-name">Régi megjegyzés:</span>
                          <span class="old-value">{{ stripNotePrefix(noteEntities['régi_megjegyzés']) }}</span>
                        </div>
                      }
                      @if (noteEntities['új_megjegyzés']) {
                        <div class="plan-change-item">
                          <span class="plan-field-name">Új megjegyzés:</span>
                          <span class="new-value">{{ stripNotePrefix(noteEntities['új_megjegyzés']) }}</span>
                        </div>
                      }
                      @if (noteEntities['törölt_megjegyzés']) {
                        <div class="plan-change-item">
                          <span class="plan-field-name">Törölt megjegyzés:</span>
                          <span class="old-value">{{ stripNotePrefix(noteEntities['törölt_megjegyzés']) }}</span>
                        </div>
                      }
                      <!-- Call center stats - naponkénti megjegyzés változások -->
                      @for (dayName of getNoteChangeDays(noteEntities); track dayName) {
                        <div class="plan-change-item">
                          <span class="plan-field-name"><mat-icon>edit_note</mat-icon> {{ dayName }}:</span>
                          @if (noteEntities[dayName]['régi_megjegyzés']) {
                            <span class="old-value">{{ stripNotePrefix(noteEntities[dayName]['régi_megjegyzés']) }}</span>
                            @if (log.status !== 'Megjegyzés törlése') {
                              &nbsp;<mat-icon class="arrow-icon">arrow_forward</mat-icon>&nbsp;
                            }
                          }
                          @if (log.status !== 'Megjegyzés törlése' || noteEntities[dayName]['új_megjegyzés']) {
                            <span class="new-value">{{ stripNotePrefix(noteEntities[dayName]['új_megjegyzés']) || '(üres)' }}</span>
                          }
                        </div>
                      }
                    </div>
                  }
                }
                <!-- Tervszám módosítás megjelenítése -->
                @if (log.status === 'Tervszám módosítás') {
                  <div class="change-item plan-changes">
                    @if (log.affected_entities && (isArray(log.affected_entities) ? log.affected_entities.length > 0 : getObjectKeys(log.affected_entities).length > 0)) {
                      <!-- Handle both array and object formats -->
                      @let entities = isArray(log.affected_entities) ? log.affected_entities[0] : log.affected_entities;
                      <!-- Notes és user name megjelenítése egy sorban -->
                      @if (log.notes) {
                        <div class="plan-notes">
                          <span class="plan-date">
                            <mat-icon>calendar_month</mat-icon>
                            {{ log.notes }}
                          </span>
                          @if (entities['user_name']) {
                            <span class="plan-user">
                              <mat-icon>account_circle</mat-icon>
                              {{ entities['user_name'] }}
                            </span>
                          }
                        </div>
                      }
                      @for (metricType of getObjectKeys(entities); track metricType) {
                        @if (metricType !== 'user_name' && metricType !== 'target_user_id') {
                          <div class="metric-group">
                            <div class="metric-title">
                              <mat-icon>assessment</mat-icon>
                              <strong>{{ metricType }}</strong>
                            </div>
                            <div class="metric-items">
                              @for (dayName of getSortedDays(entities[metricType]); track dayName) {
                                <div class="plan-change-item">
                                  <span class="plan-field-name">{{ dayName }}:</span>
                                  <span class="plan-change-values">{{ entities[metricType][dayName]['régi_érték'] }} → {{ entities[metricType][dayName]['új_érték'] }}</span>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      }
                    } @else {
                      <div style="color: red;">No affected_entities found</div>
                    }
                  </div>
                }
                @if (log.status === 'Tényszám módosítás') {
                  <div class="change-item plan-changes">
                    @if (log.affected_entities && (isArray(log.affected_entities) ? log.affected_entities.length > 0 : getObjectKeys(log.affected_entities).length > 0)) {
                      @let entities = isArray(log.affected_entities) ? log.affected_entities[0] : log.affected_entities;
                      @if (log.notes) {
                        <div class="plan-notes">
                          <span class="plan-date">
                            <mat-icon>calendar_month</mat-icon>
                            {{ log.notes }}
                          </span>
                          @if (entities['user_name']) {
                            <span class="plan-user">
                              <mat-icon>account_circle</mat-icon>
                              {{ entities['user_name'] }}
                            </span>
                          }
                        </div>
                      }
                      @for (metricType of getObjectKeys(entities); track metricType) {
                        @if (metricType !== 'user_name' && metricType !== 'target_user_id') {
                          <div class="metric-group">
                            <div class="metric-title">
                              <mat-icon>trending_up</mat-icon>
                              <strong>{{ metricType }}</strong>
                            </div>
                            <div class="metric-items">
                              @for (dayName of getSortedDays(entities[metricType]); track dayName) {
                                <div class="plan-change-item">
                                  <span class="plan-field-name">{{ dayName }}:</span>
                                  <span class="plan-change-values">{{ entities[metricType][dayName]['régi_érték'] }} → {{ entities[metricType][dayName]['új_érték'] }}</span>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      }
                    } @else {
                      <div style="color: red;">No affected_entities found</div>
                    }
                  </div>
                }
                <!-- Új naptár esemény megjelenítése -->
                @if (log.status === 'Új esemény létrehozása' && log.affected_entities && log.affected_entities[0]) {
                  @let calEntity = log.affected_entities[0];
                  <div class="change-item calendar-event-change">
                    <span class="detail-item">
                      <mat-icon>title</mat-icon>
                      Esemény: <strong>{{ calEntity.title }}</strong>
                    </span>
                    <span class="detail-item">
                      <mat-icon>category</mat-icon>
                      Típus:
                      @if (calEntity.event_type === 'appointment') {
                        <strong>Időpont egyeztetés</strong>
                      } @else if (calEntity.event_type === 'meeting') {
                        <strong>Megbeszélés</strong>
                      } @else {
                        <strong>Egyéb esemény</strong>
                      }
                    </span>
                    <span class="detail-item">
                      <mat-icon>schedule</mat-icon>
                      Kezdés: <strong>{{ formatDate(calEntity.start_time) }}</strong>
                    </span>
                    @if (calEntity.end_time) {
                      <span class="detail-item">
                        <mat-icon>schedule</mat-icon>
                        Befejezés: <strong>{{ formatDate(calEntity.end_time) }}</strong>
                      </span>
                    }
                    <span class="detail-item">
                      <mat-icon>person</mat-icon>
                      Naptár tulajdonosa: <strong>{{ calEntity.calendar_owner_name }}</strong>
                    </span>
                    @if (calEntity.kum_status) {
                      <span class="detail-item">
                        <mat-icon>flag</mat-icon>
                        KUM státusz:
                        <app-call-center-chip [config]="createKumStatusChipConfig(calEntity.kum_status)"></app-call-center-chip>
                      </span>
                    }
                    @if (calEntity.description) {
                      <div class="calendar-changes-list">
                        <div class="calendar-change-row">
                          <span class="calendar-field-name">Leírás:</span>
                          <span>{{ calEntity.description }}</span>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- Naptár esemény módosítása megjelenítése -->
                @if (log.status === 'Esemény módosítása' && log.affected_entities && log.affected_entities[0]) {
                  @let calMod = log.affected_entities[0];
                  <div class="change-item calendar-event-change">
                    <span class="detail-item">
                      <mat-icon>edit_calendar</mat-icon>
                      Esemény: <strong>{{ calMod.title }}</strong>
                    </span>
                    <span class="detail-item">
                      <mat-icon>person</mat-icon>
                      Naptár tulajdonosa: <strong>{{ calMod.calendar_owner_name }}</strong>
                    </span>
                    @if (calMod.changed_fields && getObjectKeys(calMod.changed_fields).length > 0) {
                      <div class="calendar-changes-list">
                        @for (fieldLabel of getObjectKeys(calMod.changed_fields); track fieldLabel) {
                          <div class="calendar-change-row">
                            <span class="calendar-field-name">{{ fieldLabel }}:</span>
                            <span class="change-values">
                              <span class="old-value">{{ calMod.changed_fields[fieldLabel]['régi'] }}</span>
                              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                              <span class="new-value">{{ calMod.changed_fields[fieldLabel]['új'] }}</span>
                            </span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                <!-- Naptár esemény törlése megjelenítése -->
                @if (log.status === 'Esemény törlése' && log.affected_entities && log.affected_entities[0]) {
                  @let calDel = log.affected_entities[0];
                  <div class="change-item calendar-event-change">
                    <span class="detail-item">
                      <mat-icon>event_busy</mat-icon>
                      Esemény: <strong>{{ calDel.title }}</strong>
                    </span>
                    <span class="detail-item">
                      <mat-icon>category</mat-icon>
                      Típus:
                      @if (calDel.event_type === 'appointment') {
                        <strong>Időpont egyeztetés</strong>
                      } @else if (calDel.event_type === 'meeting') {
                        <strong>Megbeszélés</strong>
                      } @else {
                        <strong>Egyéb esemény</strong>
                      }
                    </span>
                    @if (calDel.start_time) {
                      <span class="detail-item">
                        <mat-icon>schedule</mat-icon>
                        Kezdés: <strong>{{ formatDate(calDel.start_time) }}</strong>
                      </span>
                    }
                    <span class="detail-item">
                      <mat-icon>person</mat-icon>
                      Naptár tulajdonosa: <strong>{{ calDel.calendar_owner_name }}</strong>
                    </span>
                    @if (calDel.description) {
                      <div class="calendar-changes-list">
                        <div class="calendar-change-row">
                          <span class="calendar-field-name">Leírás:</span>
                          <span>{{ calDel.description }}</span>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- Naptár hozzáférés változások megjelenítése -->
                @if (log.status === 'Naptár hozzáférés' && log.affected_entities && log.affected_entities[0] && log.affected_entities[0].changes) {
                  <div class="change-item calendar-event-change">
                    @for (change of log.affected_entities[0].changes; track $index) {
                      <span class="detail-item">
                        @if (change.action === 'granted') {
                          <mat-icon style="color: #10b981;">visibility</mat-icon>
                        } @else {
                          <mat-icon style="color: #ef4444;">visibility_off</mat-icon>
                        }
                        <strong>{{ change.viewer_username }}</strong>
                        @if (change.action === 'granted') {
                          &nbsp;hozzáférést kapott&nbsp;
                        } @else {
                          &nbsp;elvesztette a hozzáférést&nbsp;
                        }
                        <strong>{{ change.target_username }}</strong>&nbsp;naptárához
                      </span>
                    }
                  </div>
                }
                <!-- Szerződés műveletek megjelenítése -->
                @if (log.contract_info) {
                  <div class="change-item contract-change">
                    @if (log.contract_info.operation === 'update' && log.status !== 'Szerződés frissítése') {
                      <div class="contract-header">
                        <span class="change-details">
                          <mat-icon>edit</mat-icon>
                          <strong>Szerződés módosítva</strong>
                        </span>
                      </div>
                    }
                    <!-- Szerződés részletek megjelenítése -->
                    <div class="contract-details">
                      @if (log.status === 'Szerződés frissítése' && log.contract_info['changes']) {
                        <!-- Szerződés frissítése esetén a változásokat jelenítjük meg -->
                        @for (changeKey of getObjectKeys(log.contract_info['changes']); track changeKey) {
                          <span class="detail-item contract-change-item">
                            <mat-icon>{{ getFieldIcon(changeKey) }}</mat-icon>
                            {{ getFieldLabel(changeKey) }}:
                            <span class="change-values">
                              <span class="old-value">{{ log.contract_info['changes'][changeKey].old_value || '-' }}</span>
                              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                              <span class="new-value">{{ log.contract_info['changes'][changeKey].new_value || '-' }}</span>
                            </span>
                          </span>
                        }
                      } @else {
                        <!-- Hagyományos szerződés részletek megjelenítése -->
                        @for (field of getContractFields(log.contract_info); track field.key) {
                          <span class="detail-item">
                            <mat-icon>{{ field.icon }}</mat-icon>
                            {{ field.label }}: <strong>{{ field.value }}</strong>
                          </span>
                        }
                      }
                    </div>
                  </div>
                }
                <!-- Új illusztráció műveletek megjelenítése -->
                @if (isIllustrationLog(log)) {
                  <div class="change-item illustration-change">
                    @let illustrationData = getIllustrationData(log);
                    <!-- Területek és ügyfelek megjelenítése -->
                    @if (illustrationData.areas && illustrationData.areas.length > 0) {
                      <div class="areas-container">
                        @for (area of illustrationData.areas; track $index) {
                          <div class="area-block">
                            <div class="area-title">
                              <mat-icon>category</mat-icon>
                              <strong>{{ area.area }}</strong>
                            </div>
                            @if (area.customers && area.customers.length > 0) {
                              <div class="area-customers">
                                @for (customer of area.customers; track $index) {
                                  <div class="customer-item">
                                    <mat-icon>person</mat-icon>
                                    <span class="customer-name">{{ customer.fullname }}</span>
                                    @if (customer.birthdate) {
                                      <span class="customer-birthdate">
                                        ({{ formatDateOnly(customer.birthdate) }})
                                      </span>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                <!-- Adatok feltöltése műveletek megjelenítése -->
                @if (log.affected_entities && log.affected_entities[0] && (log.affected_entities[0].company || log.affected_entities[0].customer) && log.affected_entities[0].action === 'created') {
                  <div class="change-item data-upload-change">
                    <!-- Cég adatok megjelenítése -->
                    @if (log.affected_entities[0].company) {
                      <div class="company-data">
                        <div class="company-details">
                          @if (log.affected_entities[0].company.tax_number) {
                            <span class="detail-item">
                              <mat-icon>receipt</mat-icon>
                              Adószám: {{ log.affected_entities[0].company.tax_number }}
                            </span>
                          }
                          @if (log.affected_entities[0].company.opten_id) {
                            <span class="detail-item">
                              <mat-icon>badge</mat-icon>
                              Opten ID: {{ log.affected_entities[0].company.opten_id }}
                            </span>
                          }
                          @if (log.affected_entities[0].company.address) {
                            <span class="detail-item">
                              <mat-icon>location_on</mat-icon>
                              Cím: {{ log.affected_entities[0].company.address }}
                            </span>
                          }
                          @if (log.affected_entities[0].company.county) {
                            <span class="detail-item">
                              <mat-icon>map</mat-icon>
                              Megye: {{ log.affected_entities[0].company.county }}
                            </span>
                          }
                          @if (log.affected_entities[0].company.main_activity) {
                            <span class="detail-item">
                              <mat-icon>work</mat-icon>
                              Főtevékenység: {{ log.affected_entities[0].company.main_activity }}
                            </span>
                          }
                          @if (hasNumericValue(log.affected_entities[0].company.net_revenue)) {
                            <span class="detail-item">
                              <mat-icon>payments</mat-icon>
                              Nettó árbevétel: {{ formatNetRevenue(log.affected_entities[0].company.net_revenue) }}
                            </span>
                          }
                          @if (log.affected_entities[0].company.employee_count && log.affected_entities[0].company.employee_count !== 0) {
                            <span class="detail-item">
                              <mat-icon>groups</mat-icon>
                              Alkalmazottak száma: {{ log.affected_entities[0].company.employee_count }} fő
                            </span>
                          }
                        </div>
                        <!-- Tisztségviselők megjelenítése -->
                        @if (log.affected_entities[0].customers && log.affected_entities[0].customers.length > 0) {
                          <div class="customers-data">
                            <div class="customers-simple-list">
                              @for (customer of log.affected_entities[0].customers; track customer.full_name) {
                                <div class="customer-simple-text">
                                  <mat-icon>person</mat-icon>
                                  <span class="customer-text-content">
                                    {{ customer.full_name }}@if (customer.address) {, {{ customer.address }}}@if (customer.birth_date) {, szül.: {{ formatDateOnly(customer.birth_date) }}}
                                  </span>
                                </div>
                              }
                            </div>
                          </div>
                        }
                        <!-- Email címek megjelenítése -->
                        @if (log.affected_entities[0].emails && log.affected_entities[0].emails.length > 0) {
                          <div class="emails-data">
                            <div class="emails-list">
                              @for (emailItem of log.affected_entities[0].emails; track emailItem.email) {
                                <span class="email-item">
                                  <mat-icon>email</mat-icon>
                                  {{ emailItem.email }}
                                </span>
                              }
                            </div>
                          </div>
                        }
                        <!-- Telefonszámok megjelenítése -->
                        @if (log.affected_entities[0].phones && log.affected_entities[0].phones.length > 0) {
                          <div class="phones-data">
                            <div class="phones-list">
                              @for (phoneItem of log.affected_entities[0].phones; track phoneItem.phone) {
                                <span class="phone-item">
                                  <mat-icon>phone</mat-icon>
                                  {{ phoneItem.phone }}
                                </span>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <!-- Egyedi ügyfél adatok megjelenítése -->
                    @if (log.affected_entities[0].customer && !log.affected_entities[0].company) {
                      <div class="customer-data">
                        <div class="customer-details">
                          @if (log.affected_entities[0].customer.address) {
                            <span class="detail-item">
                              <mat-icon>home</mat-icon>
                              Cím: {{ log.affected_entities[0].customer.address }}
                            </span>
                          }
                          @if (log.affected_entities[0].customer.birth_date) {
                            <span class="detail-item">
                              <mat-icon>cake</mat-icon>
                              Születési dátum: {{ formatDateOnly(log.affected_entities[0].customer.birth_date) }}
                            </span>
                          }
                          @if (log.affected_entities[0].customer.tax_number) {
                            <span class="detail-item">
                              <mat-icon>receipt</mat-icon>
                              Adószám: {{ log.affected_entities[0].customer.tax_number }}
                            </span>
                          }
                          @if (log.affected_entities[0].customer.birth_place) {
                            <span class="detail-item">
                              <mat-icon>place</mat-icon>
                              Születési hely: {{ log.affected_entities[0].customer.birth_place }}
                            </span>
                          }
                          @if (log.affected_entities[0].customer.mother_name) {
                            <span class="detail-item">
                              <mat-icon>family_restroom</mat-icon>
                              Anyja neve: {{ log.affected_entities[0].customer.mother_name }}
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- Meglévő cég kiegészítése -->
                @if (log.affected_entities && log.affected_entities[0] && log.affected_entities[0].action === 'enriched') {
                  @let enriched = log.affected_entities[0];
                  <div class="change-item enriched-change">
                    <div class="company-data">
                      @if (enriched.updated_fields && enriched.updated_fields.length > 0) {
                        <div class="company-details">
                          @for (item of enriched.updated_fields; track item.field) {
                            <span class="detail-item">
                              <mat-icon>edit</mat-icon>
                              {{ getFieldDisplayName(item.field) }}: {{ getFieldDisplayValue(item.field, item.value) }}
                            </span>
                          }
                        </div>
                      }
                      @if (enriched.customers && enriched.customers.length > 0) {
                        <div class="customers-data">
                          <div class="customers-simple-list">
                            @for (customer of enriched.customers; track customer.full_name) {
                              <div class="customer-simple-text">
                                <mat-icon>person_add</mat-icon>
                                <span class="customer-text-content">Új tisztségviselő: {{ customer.full_name }}</span>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      @if (enriched.emails && enriched.emails.length > 0) {
                        <div class="emails-data">
                          <div class="emails-list">
                            @for (emailItem of enriched.emails; track emailItem.email) {
                              <span class="email-item">
                                <mat-icon>email</mat-icon>
                                Új email cím: {{ emailItem.email }}
                              </span>
                            }
                          </div>
                        </div>
                      }
                      @if (enriched.phones && enriched.phones.length > 0) {
                        <div class="phones-data">
                          <div class="phones-list">
                            @for (phoneItem of enriched.phones; track phoneItem.phone) {
                              <span class="phone-item">
                                <mat-icon>phone</mat-icon>
                                Új telefonszám: {{ phoneItem.phone }}
                              </span>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- Eredeti affected entities megjelenítése (array formátum) -->
                @if (log.affected_entities && log.affected_entities.length) {
                  @for (entity of log.affected_entities; track $index) {
                    @if (entity.type === 'status_change') {
                      <div class="change-item status-change">
                        <app-call-center-chip [config]="createStatusChipConfig(entity.old_value || '')"></app-call-center-chip>
                        <mat-icon>arrow_forward</mat-icon>
                        <app-call-center-chip [config]="createStatusChipConfig(entity.new_value || '')"></app-call-center-chip>
                      </div>
                    }
                    @if (entity.type === 'official_edited') {
                      <div class="change-item official-edited">
                        <mat-icon class="edit-icon">edit</mat-icon>
                        <span class="change-values">
                          <span class="old-value">{{ entity.old_value }}</span>
                          <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                          <span class="new-value">{{ entity.new_value }}</span>
                        </span>
                      </div>
                    }
                    @if (entity.type === 'reminder_set') {
                      <div class="change-item reminder-set">
                        <mat-icon class="reminder-icon">notifications_active</mat-icon>
                        <span>Emlékeztető: {{ entity.reminder_time | date:'yyyy.MM.dd. HH:mm' }}</span>
                      </div>
                    }
                  }
                  <!-- Kontakt változások külön grid konténerben -->
                  @if (hasContactChanges(log.affected_entities)) {
                    <div class="contacts-grid">
                      @for (entity of log.affected_entities; track $index) {
                        @if (entity.type === 'contact_validated') {
                          <div class="change-item contact-validation">
                            <strong>{{ entity.entity_value }}</strong>
                            @if (entity.status_text === 'Megerősítve') {
                              <mat-icon class="contact-status-icon confirmed">check_circle</mat-icon>
                            } @else if (entity.status_text === 'Elutasítva') {
                              <mat-icon class="contact-status-icon rejected">cancel</mat-icon>
                            } @else {
                              <mat-icon class="contact-status-icon default">radio_button_unchecked</mat-icon>
                            }
                          </div>
                        }
                        @if (entity.type === 'contact_added') {
                          <div class="change-item contact-added">
                            <mat-icon>add</mat-icon>
                            <span class="contact-value">{{ entity.contact_value }}</span>
                            @if (entity.valid_status === true) {
                              <mat-icon class="contact-status-icon confirmed">check_circle</mat-icon>
                            } @else if (entity.valid_status === false) {
                              <mat-icon class="contact-status-icon rejected">cancel</mat-icon>
                            }
                          </div>
                        }
                        @if (entity.type === 'contact_edited') {
                          <div class="change-item contact-edited">
                            <mat-icon class="edit-icon">edit</mat-icon>
                            <span class="change-values">
                              <span class="old-value">{{ entity.old_value }}</span>
                              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                              <span class="new-value">{{ entity.new_value }}</span>
                            </span>
                          </div>
                        }
                      }
                    </div>
                  }
                  @for (entity of log.affected_entities; track $index) {
                    @if (entity.type === 'modify_nickname') {
                      <span class="change-item nickname-change">
                        <mat-icon>edit</mat-icon>
                        <span class="change-values">{{ entity.old_value }} → {{ entity.new_value }}</span>
                      </span>
                    }
                    @if (entity.type === 'company_edit') {
                      <div class="change-item company-edit">
                        @for (change of getCompanyChanges(entity.changes); track change.field) {
                          <div class="field-change">
                            <strong>{{ getFieldDisplayName(change.field) }}:</strong>
                            <span class="change-values">
                              {{ formatBeforeValue(change.before) }} → {{ change.after }}
                            </span>
                          </div>
                        }
                      </div>
                    }
                    @if (entity.type === 'individual_edit') {
                      <div class="change-item individual-edit">
                        @for (change of getCompanyChanges(entity.changes); track change.field) {
                          <div class="field-change">
                            <strong>{{ getFieldDisplayName(change.field) }}:</strong>
                            <span class="change-values">
                              {{ formatBeforeValue(change.before) }} → {{ change.after }}
                            </span>
                          </div>
                        }
                      </div>
                    }
                    @if (entity.type === 'data_change') {
                      <span class="change-item data-change">
                        <mat-icon>edit</mat-icon>
                        Adat módosítás:
                        <span class="field-name">{{ entity.entity_type }}</span>
                        <mat-icon>arrow_forward</mat-icon>
                        <span class="new-value">{{ entity.new_value }}</span>
                      </span>
                    }
                    @if (entity.type !== 'status_change' && entity.type !== 'contact_validated' && entity.type !== 'contact_added' && entity.type !== 'contact_edited' && entity.type !== 'data_change' && entity.type !== 'company_edit' && entity.type !== 'individual_edit' && entity.type !== 'modify_nickname' && entity.type !== 'official_edited' && entity.type !== 'reminder_set') {
                      <span class="change-item other-entity">
                        {{ entity.entity_value || entity.new_value }}
                      </span>
                    }
                  }
                }
                <!-- Megjegyzések (csak akkor jelenítjük meg, ha nincs affected_entities vagy ha nem ügyfél/cég létrehozás vagy tervszám/tényszám módosítás) -->
                @if (log.notes && (!log.affected_entities || (log.status !== 'Ügyfél létrehozása' && log.status !== 'Adatok feltöltése' && log.status !== 'Tervszám módosítás' && log.status !== 'Tényszám módosítás' && log.status !== 'Új megjegyzés' && log.status !== 'Megjegyzés szerkesztése' && log.status !== 'Megjegyzés törlése'))) {
                  <span class="change-item notes">
                    <span class="notes-label">Megjegyzések:</span> {{ log.notes }}
                  </span>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>

<!-- Pagination -->
@if (!hidePaginator) {
  <mat-paginator
    [length]="totalLogs"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
    class="logs-paginator">
  </mat-paginator>
}
}